import React, { useEffect, useState } from "react";
import Card from "../Card";
import "./style.scss";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RightArrow } from "../../../Assets/right-arrow.svg";
import { useMediaQuery } from "react-responsive";
import { Col, Row, Skeleton } from "antd";
import CategoryCard from "../CategoryCard";
import PropTypes from "prop-types";
import NoEvents from "../../../Assets/no-events.png";

const EventsListing = ({
  eventList,
  hideViewAll,
  styleClass,
  carousel = true,
}) => {
  EventsListing.propTypes = {
    eventList: PropTypes.object,
    hideViewAll: PropTypes.bool,
    styleClass: PropTypes.string,
    carousel: PropTypes.bool,
  };

  const isLaptop = useMediaQuery({ maxWidth: 1650 });
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const navigate = useNavigate();
  const [scrollIndex, setScrollIndex] = useState(0);

  useEffect(() => {
    setScrollIndex(0);
  }, [isLaptop]);

  const returnMaxLength = () => {
    if (isLaptop) {
      return 3;
    } else {
      return 4;
    }
  };

  const returnMaxScrollIndex = () =>
    eventList.events.length - returnMaxLength();

  const handleScroll = () => {
    const nextScrollIndex = scrollIndex + 1;
    const maxScrollIndex = returnMaxScrollIndex();
    if (nextScrollIndex > maxScrollIndex) {
      setScrollIndex(0);
    } else {
      setScrollIndex(nextScrollIndex);
    }
  };

  return (
    <div className={`eventListing ${styleClass}`}>
      {eventList?.title && (
        <header>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src={eventList.icon} width="28px" height="28px" alt="icon" />
            <div className="heading-title">{eventList?.title}</div>
          </div>

          {!hideViewAll && eventList.categories == null && (
            <div
              className="button"
              style={{ borderRadius: 8 }}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/events");
              }}
              onKeyDown={() => {
                window.scrollTo(0, 0);
                navigate("/events");
              }}
            >
              View All <RightOutlined />
            </div>
          )}
        </header>
      )}
      <div className="listing-container category-listing">
        {eventList.categories != null ? (
          <Row gutter={isMobile ? [12, 12] : [24, 24]}>
            {eventList?.categories?.map((item, index) => (
              <Col
                key={`Event-Category-${item.text}`}
                xs={12}
                md={isLaptop ? 8 : 6}
              >
                <CategoryCard data={item} index={index} />
              </Col>
            ))}
          </Row>
        ) : (
          <>
            {carousel && scrollIndex > 0 && (
              <RightArrow className="left-scroller" onClick={handleScroll} />
            )}
            {carousel ? (
              <div
                className="listing"
                style={{
                  transform: `translateX(-${
                    scrollIndex * (100 / returnMaxLength())
                  }%)`,
                }}
              >
                {eventList?.events == null
                  ? [1, 2, 3].map((item, index) => (
                      <Skeleton.Button
                        active
                        className="skeleton-card"
                        key={`Event-List-Skeleton-${item}`}
                      />
                    ))
                  : eventList?.events?.map((item, index) => (
                      <Card
                        key={`Event-Lt-${item.id}`}
                        data={item}
                        index={index}
                      />
                    ))}
              </div>
            ) : (
              <Row gutter={[24, 24]}>
                {eventList?.events == null ? (
                  [1, 2, 3].map((item, index) => (
                    <Skeleton.Button
                      active
                      className="skeleton-card"
                      key={`Event-List-Skeleton-${item}`}
                    />
                  ))
                ) : eventList?.events?.length === 0 ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                    className="no-event-text-container"
                  >
                    <img src={NoEvents} alt="No Events" />
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 24,
                        fontFamily: "Inter",
                      }}
                      className="no-current-events"
                    >
                      No current events in this category
                    </div>
                    <div
                      style={{
                        fontWeight: 400,
                        fontSize: 20,
                        color: "#666666",
                        marginTop: 16,
                        textAlign: "center",
                      }}
                      className="no-current-events-description"
                    >
                      Looks like we don’t have any events related
                      <br />
                      to the search in this category
                    </div>
                  </div>
                ) : (
                  eventList?.events?.map((item, index) => (
                    <Col
                      xs={24}
                      md={isLaptop ? 12 : 8}
                      key={`Event-Lt-${item.id}`}
                    >
                      <Card data={item} index={index} />
                    </Col>
                  ))
                )}
              </Row>
            )}
            {carousel &&
              eventList?.events?.length > returnMaxLength() &&
              scrollIndex < returnMaxScrollIndex() && (
                <RightArrow className="scroller" onClick={handleScroll} />
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default EventsListing;
